import { Injectable } from "@angular/core";
import { ApiService } from "../global.service";
import { Category } from './interfaces/categories.interface'
import { Observable } from "rxjs";
import { HttpBackend, HttpClient } from "@angular/common/http";

import { environment } from '../../../environments/environment';
import { ConfigService } from "../config.service";
import { BusinessContextService } from "../business-context.service";
import { LocalStorageService } from "../storage.service";

// const URL = environment.API_URL;
// const CUSTOMER = environment.CUSTOMER;

@Injectable({
    providedIn: 'root'
})
export class CategoryService extends ApiService {
    constructor(
        public override http: HttpClient,
        public override config: ConfigService,
        public override localStorageService: LocalStorageService,
        handler: HttpBackend,
        private bizCtx: BusinessContextService,
    ) {
        super(http, config, localStorageService, handler);
    }

    private getBusiness(): string {
        // Fallback to legacy CUSTOMER if selection not present
        return this.bizCtx.getSelected() || this.CUSTOMER;
    }

    getCategories(): Observable<Category[]> {
        const business = this.getBusiness();
        return this.get<Category[]>(`${this.URL}/category/${business}`);
    }

    createTable(table: Category): Observable<Category> {
        const business = this.getBusiness();
        return this.create<Category>(`${this.URL}/category/${business}`, table);
    }

    updateTable(table: Category): Observable<Category> {
        const business = this.getBusiness();
        return this.update<Category>(`${this.URL}/category/${table.uuid}/${business}`, table);
    }

    // Create category
    createCategory(payload: { name: string; slug?: string; enabled?: boolean }): Observable<Category> {
        const business = this.getBusiness();
        return this.create<Category>(`${this.URL}/category/${business}`, payload);
    }

    // Update category (rename, toggle, etc.) via PATCH
    // If identifier is numeric -> PATCH /category/:id
    // Else -> PATCH /category/by-uuid/:uuid
    updateCategory(identifier: string | number, payload: Partial<Category>): Observable<Category> {
        let url: string;
        if (typeof identifier === 'number' || /^\d+$/.test(String(identifier))) {
            url = `${this.URL}/category/${identifier}`;
        } else {
            // Canonical endpoint per requirement: PATCH /category/by-uuid/:uuid
            url = `${this.URL}/category/by-uuid/${identifier}`;
        }
        // Use ApiService.patch to ensure headers (Authorization, Content-Type) and X-Business-Uuid
        return this.patch<Category>(url, payload as any);
    }

    // Delete a category by numeric id when available, otherwise by uuid via /category/by-uuid/:uuid
    deleteCategory(identifier: string | number): Observable<void> {
        let url: string;
        if (typeof identifier === 'number' || /^\d+$/.test(String(identifier))) {
            // Backend route expects numeric id without customer segment
            url = `${this.URL}/category/${identifier}`;
        } else {
            // Canonical route deletes by UUID
            url = `${this.URL}/category/by-uuid/${identifier}`;
        }
        // Use ApiService.delete to ensure Authorization and X-Business-Uuid headers are attached
        return this.delete<void>(url);
    }

    // Link portion to one or more categories
    linkPortionToCategories(payload: { portionUuid: string; categoryUuids: string[] }): Observable<any> {
        const business = this.getBusiness();
        return this.create<any>(`${this.URL}/category-portion/${business}`, payload);
    }

    // Unlink portion from a single category
    unlinkPortionFromCategory(payload: { portionUuid: string; categoryUuid: string }): Observable<any> {
        const business = this.getBusiness();
        return this.delete<any>(`${this.URL}/category-portion/${business}`, payload);
    }
}